import { cleanUpForm } from '@/utils/common'
import axios from 'axios'

// const DEBUG_ENV = process.env
// console.log(DEBUG_ENV)

const ENV = process.env.NODE_ENV === "production" ? "prod" : "dev"

const checkEligibility = (form) =>
  axios.post(
    '/api/checkEligibility',
    cleanUpForm(form)
  )

const signatureForm = (form) =>
  axios.post(
    `/api/notify/website/${ENV}/msm-website-consent-form`,
    cleanUpForm(form)
  )

const questionnaireForm = (form) =>
  axios.post(`/api/notify/website/${ENV}/msm-website-survey`,
  cleanUpForm(form)
)

const questionnaireFormCRC = (form) =>
  axios.post(`/api/notify/website/${ENV}/msm-website-survey-crc`,
  cleanUpForm(form)
)

const msmApi = {
  checkEligibility,
  signatureForm,
  questionnaireForm,
  questionnaireFormCRC
}

export { msmApi }
